import { useNotification } from '@refinedev/core';

interface UseDisplayErrorNotificationReturn {
  handleNoDataFound: (query: string) => void;
  handleInvalidData: (entity: string, errorMessage: string) => void;
}

export const useDisplayErrorNotification =
  (): UseDisplayErrorNotificationReturn => {
    const { open } = useNotification();

    const handleNoDataFound = (query: string) => {
      open?.({
        message: `No data found for ${query}`,
        type: 'error',
        key: `${query}`,
      });
    };

    const handleInvalidData = (entity: string, errorMessage: string) => {
      open?.({
        message: `Invalid data for ${entity}: ${errorMessage}`,
        type: 'error',
        key: `invalid-data-${entity}`,
      });
    };

    return {
      handleNoDataFound,
      handleInvalidData,
    };
  };
